import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { baseApiUrl } from "../data/url";
import { countries } from "../data/countries";
import sortLeaguesByFixtureCount from "../functions/sortLeagues";
import replaceBookingCode from "../functions/replaceBookingCode";
import generateBookingCode from "../functions/generateBookingCode";

const AppContext = createContext();

const AppProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [balance, setBalance] = useState(0);
    const [popup, setPopup] = useState(null);
    const [reload, setReload] = useState(false);
    const [transactions, setTransactions] = useState([]);
    const [countryCode, setCountryCode] = useState(null);
    const [modalLoading, setModalLoading] = useState({});
    const [dropDown, setDropDown] = useState(null);
    const [loadedTickets, setLoadedTickets] = useState({
        tickets: [],
        openVisited: false,
        settledVisited: false
    });
    const [sportTypes, setSportTypes] = useState([]);
    const [highlights, setHighlights] = useState(null);
    const [subUrl, setSubUrl] = useState('');

    const country = useMemo(()=>countries.find(item => item.id == countryCode) || {}, [countryCode])

    function init() {

        console.log("User: ", user);

        setTimeout(() => {
            window.$.ajax({
                url: `${baseApiUrl}/get-balance.php`,
                dataType: 'JSON',
                type: 'POST',
                data: { user: user },
                success: (res) => {
                    // console.log(res)
                    if (res.status = 'success') setBalance(res.data.balance)
                    else setBalance(400)
                },
                error: (res) => {
                    // console.log(res)
                    setBalance(400)
                }
            })
        }, 2000)

        getTransactions();

        window.$.ajax({
            url: `${baseApiUrl}/get-tickets.php`,
            dataType: 'JSON',
            type: 'POST',
            data: { user: user },
            success: (data) => {
                console.log(data)
                if (data.status == 'success') {

                    let tempTickets = data.data;

                    tempTickets.forEach((ticket, i) => {

                        if (ticket.status == 'open') {

                        } else {
                            let losts = 0;
                            let cashouts = 0;
                            let winWithVoids = 0;
                            let filter;

                            ticket.matches.forEach(match => {
                                if (match.winningSelection == '') cashouts++;
                                else if (match.winningSelection == 'NotResulted') winWithVoids++;
                                else if (match.winningSelection != match.userSelection) losts++;
                            })

                            if (losts > 0) filter = 'Loss';
                            else if (cashouts > 0) filter = 'Cash Out'
                            else if (winWithVoids > 0) filter = 'Win with void(s)'
                            else filter = 'Win'

                            tempTickets[i].filter = filter
                        }
                    });

                    tempTickets.sort((a, b) => Number(b.id) - Number(a.id));

                    // if (country.id) {
                    //     console.log("Country Selected: ", countryCode);
                    //     tempTickets = tempTickets.map(ticket => ({
                    //         ...ticket,
                    //         bookingCode: ticket.bookingCode ? replaceBookingCode(ticket.bookingCode, country.bookingCodePrefix) : generateBookingCode(country.bookingCodePrefix)
                    //     }))
                    // }

                    setLoadedTickets(prev => ({ ...prev, tickets: tempTickets }));
                } else {
                    console.log(data.message);
                }
            },
            error: (res) => {
                console.log(res)
            }
        })

    }

    function getTransactions(){
        window.$.ajax({
            url: `${baseApiUrl}/get-transactions.php`,
            dataType: 'JSON',
            type: 'POST',
            data: { user: user, limit: 100 },
            success: (res) => {
                // console.log(res)
                if (res.status = 'success') setTransactions(res.data.transactions)
                else setBalance(400)
            },
            error: (res) => {
                // console.log(res)
                setBalance(400)
            }
        })
    }

    function toggleDropDown(e, dropDownName = null) {
        e.stopPropagation();
        if (dropDown == dropDownName) {
            setDropDown(null);
        } else {
            setDropDown(dropDownName);
        }
    }

    function logout() {

        const ask = window.confirm("Are you sure you want to Logout?");
        if (ask) {
            setUser(null);
            logoutCleanUp();
        }
    }

    function logoutCleanUp() {
        setLoadedTickets({
            tickets: [],
            openVisited: false,
            settledVisited: false
        });
        setTimeout(()=>setPopup(null), 200);
        setReload(false);
        setBalance(0);

        setTransactions(null);
    }

    useEffect(() => {
        const url = window.location.href;
        const urlParamSide = url.split('?')[1];
        const params = urlParamSide?.split('&');
        const allParams = {};
        if (params) {
            for (const param of params) {
                const paramSplit = param.split('=')
                allParams[paramSplit[0]] = paramSplit[1]
            }
        }
        const localCountryCode = localStorage.getItem('country');
        if (localCountryCode) {
            setCountryCode(localCountryCode);
        } else {
            setCountryCode(2);
        }

        if (allParams.user) {
            setUser(allParams.user);
        } else {
            const localUser = localStorage.getItem('user');
            if (localUser) {
                setUser(localUser);
            }
        }
    }, [])

    useEffect(() => {
        if (user) {
            init();
            localStorage.setItem('user', user);
        } else {
            localStorage.removeItem('user');
        }
    }, [user])

    console.log(user, countryCode, balance);

    useEffect(() => {
        if (user) init();
    }, [user])

    useEffect(() => {
        if (popup) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
    }, [popup])

    useEffect(() => {
        if (countryCode !== null) localStorage.setItem("country", countryCode);
        // if (country.id) {
        //     setLoadedTickets(prev => ({
        //         ...prev,
        //         tickets: prev.tickets.map(ticket => ({
        //             ...ticket,
        //             bookingCode: ticket.bookingCode ? replaceBookingCode(ticket.bookingCode, country.bookingCodePrefix) : generateBookingCode(country.bookingCodePrefix)
        //         }))
        //     }))
        // }
        if (countryCode == null) return
        // getSportTypes();
        // getHighlights();
    }, [countryCode])

    function showModal({
        loadingDelay = 0,
        modalId,
        data = null,
        callback = null
    }){
        setPopup(null);
        if(loadingDelay > 0){
            setModalLoading(prev => ({ ...prev, [modalId]: true }))
        }
        console.log("Loading Delay: ",loadingDelay);
        setTimeout(()=>{
            setPopup(modalId);
            if(loadingDelay > 0) setModalLoading(prev => ({ ...prev, [modalId]: false }));
            if(callback) callback(data);
        }, loadingDelay)
    }

    return (
        <AppContext.Provider value={{
            user,
            setUser,
            popup,
            setPopup,
            reload,
            setReload,
            showModal,
            loadedTickets,
            setLoadedTickets,
            transactions,
            setTransactions,
            getTransactions,
            balance: balance * country?.factor,
            setBalance,
            country,
            setCountryCode,
            dropDown,
            toggleDropDown,
            sportTypes,
            setSportTypes,
            highlights,
            setHighlights,
            subUrl,
            setSubUrl,
            modalLoading,
            setModalLoading: (key, value) => setModalLoading(prev => ({ ...prev, [key]: value })),
            init,
            logout,
        }}>
            {children}
        </AppContext.Provider>
    );
}

export default AppProvider;
export const useApp = () => useContext(AppContext);

